import React, { useState } from "react";
import { useQuery } from "react-query";
import Loading from "../Shared/Loading";
import SingleBrandProduct from "./SingleBrandProduct";

const AllBrandProducts = ({ brand_slug }) => {
  const [loading, setLoading] = useState(true);
  const { data: brandProducts, isLoading } = useQuery("brandProducts", () =>
    fetch(
      `https://evening-peak-35730.herokuapp.com/products/${brand_slug}`
    ).then((res) => {
      setLoading(false);
      return res.json();
    })
  );

  if (isLoading || loading) {
    return <Loading></Loading>;
  }

  return (
    <div className="my-14">
      <div className="flex justify-center">
        <div className="grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {brandProducts.map((product) => (
            <SingleBrandProduct
              key={product._id}
              product={product}
            ></SingleBrandProduct>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AllBrandProducts;
